import { generateUUID } from "./uuid";

// Using this names lets the styled-components editor plugin do syntax highlighting
// and prettier to format the code
export function styled() {
  // May look crazy, but is just how these template literal functions are invoked
  return function (strings, ...values) {
    const styleId = generateUUID();
    const style = window.document.createElement("style");
    style.id = styleId;
    style.innerHTML = strings.reduce((result, value, index) => {
      if (value && values[index]) {
        result += value + values[index];
      }
      return result;
    }, "");
    window.document.head.appendChild(style);
    return styleId;
  };
}

export function contains(outer, inner) {
  return outer && inner instanceof Node && outer.contains(inner);
}

export function removeStyle(id: string): void {
  const el = window.document.getElementById(id);
  if (el) {
    el.remove();
  }
}

// https://gomakethings.com/how-to-get-the-first-and-last-focusable-elements-in-the-dom/

export function getFocusableElements(node) {
  return node.querySelectorAll(
    'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
}

// TODO: Currently only handles y
function findNearestScrollParent(node) {
  function isScrollable(el) {
    return getComputedStyle(el)["overflow-y"] === "auto";
  }

  if (isScrollable(node)) {
    return node;
  } else if (node.parentElement) {
    return findNearestScrollParent(node.parentElement);
  }
  return null;
}

/**
 * Make sure the given child element is fully visible in it's scrollable
 * parent. If it's not, put it all the way to the left.
 * element.scrollIntoView can overscroll and look bad in IE11
 * TODO: Currently only handles y
 */
export function scrollIntoView(node) {
  if (!node) {
    return;
  }

  const parent = findNearestScrollParent(node);
  if (parent) {
    const height = parent.offsetHeight;
    const scrollY = parent.scrollTop;
    const { top: itemTop, height: itemHeight } = node.getBoundingClientRect();
    const { top: parentTop } = parent.getBoundingClientRect();
    const itemY = itemTop - parentTop + scrollY;
    if (itemY < scrollY || itemY + itemHeight > scrollY + height) {
      parent.scrollTop = itemY;
    }
  }
}

/**
 * If the element has a scrolled parent, undo that scroll. The expected use
 * is suppressing/undoing the browser's attempts to scroll a focused element
 * into view when the element is not in a scrollable context and has special
 * handling of that behavior
 * @param el HTMLElement starting point for parent search. The element itself
 *           is not checked
 */
export function undoParentScroll(el: HTMLElement): void {
  const parent = el.parentElement;
  if (parent) {
    if (parent.scrollTop > 0) {
      parent.scrollTop = 0;
    }
    if (parent.scrollLeft > 0) {
      parent.scrollLeft = 0;
    }

    undoParentScroll(parent);
  }
}
